import template from './room-area.jade';
import validation from './../../../services/validation';

import { initializeSegmentInputTooltips } from '../../../utils/segment-input-tooltips';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular.module('cian.addForm.roomArea', []).directive('cianAfAboutObjectRoomArea', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    '$scope',
    'adTooltipsService',
    'analyticsService',
    'deviceService',
    'popupService',
    'store',
    function ($scope, adTooltipsService, analyticsService, deviceService, popupService, store) {
      this.isMobile = deviceService.isMobile;
      this.modalHintTitle = 'Площадь комнаты';
      this.tooltipText = '';
      this.areaMin = 0;
      this.areaMax = 100000;
      this.validation = validation(this.form, 'roomArea', {
        parse: 'Введите число',
        required: 'Укажите площадь комнаты',
        min: 'Площадь должна быть больше 0',
        max: 'Допустимо не более 5 символов',
      });

      let trackedValue;

      this.handleBlur = () => {
        const value = this.ad.roomArea;

        if (value && value !== trackedValue) {
          const state = store.getState();
          const category = selectAnalyticsOfferStatus(state);

          trackRequiredFieldFill(category, 'room_area');
          trackedValue = value;
        }
      };

      initializeSegmentInputTooltips({
        controller: this,
        $scope,
        adTooltipsService,
        adAnalyticsCategory: analyticsService.adAnalyticsCategory,
        tooltipsKey: 'roomArea',
        trackingLabel: 'room-area-hint',
        popupService,
        isMobile: this.isMobile,
      });
    },
  ],
  controllerAs: 'roomArea',
  template,
})).name;
